import React from "react";
import { Col, Row, Image } from "react-bootstrap";
import { NavLink } from "react-router-dom";

import isEmpty from "../../../../store/validation/is-Empty";

const AboutSection = (props) => {
  return (
    <React.Fragment>
      <div className="d-flex align-items-center">
        <div className="f16-700 mr-1">Map Setup</div>
        <NavLink to="/editmapsetup" className="enIconBtnGraySmall">
          <Image
            src={require("../../../../assets/images/UserManagement/pencil.svg")}
            alt="Edit"
            title="Edit"
            fluid
          />
        </NavLink>
      </div>
      <hr /> 
      <div className="d-flex align-items-center pb-4">
        <div className="f16-700 mr-1">Business Details</div>
        <NavLink to="/editrestaurantdetails" className="enIconBtnGraySmall">
          <Image
            src={require("../../../../assets/images/UserManagement/pencil.svg")}
            alt="Edit"
            title="Edit"
            fluid
          />
        </NavLink>
      </div>
      <Row>
        <Col md={6} lg={4} xl={3} xs={4} className="pb-4" style={{borderRight: "1px solid #E0E0E0"}}>
          <div className="f14-700 pb-2">Business Name</div>
          <div className="f12-400">{props.vendor.restaurant_name}</div>
        </Col>
        <Col md={6} lg={4} xl={3} xs={4} className="pb-4" style={{borderRight: "1px solid #E0E0E0"}}>
          <div className="f14-700 pb-2">Phone No.</div>
          <div className="f12-400">
            {!isEmpty(props.vendor.contact_detail) &&
              props.vendor.contact_detail.map((singleitem, index) => {
                return (
                  <React.Fragment key={index}>
                    {singleitem.country_code + " " + singleitem.mobile_no}
                  </React.Fragment>
                );
              })}
          </div>
        </Col>
        <Col md={6} lg={4} xl={3} xs={4} className="pb-4" style={{borderRight: "1px solid #E0E0E0"}}>
          <div className="f14-700 pb-2">Business Address</div>
          <div className="f12-400">{props.vendor.restaurant_address}</div>
        </Col>
        <Col md={6} lg={4} xl={3} xs={4} className="pb-4" style={{borderRight: "1px solid #E0E0E0"}}>
          <div className="f14-700 pb-2">Area</div>
          <div className="f12-400">{props.vendor.area}</div>
        </Col>
        <Col md={6} lg={4} xl={3} xs={4} className="pb-4" style={{borderRight: "1px solid #E0E0E0"}}>
          <div className="f14-700 pb-2">City</div>
          <div className="f12-400">{props.vendor.city}</div>
        </Col>
        <Col md={6} lg={4} xl={3} xs={4} className="pb-4" style={{borderRight: "1px solid #E0E0E0"}}>
          <div className="f14-700 pb-2">Enquiry Email</div>
          <div className="f12-400 text-break">
            {!isEmpty(props.vendor.enquiry_email) &&
              props.vendor.enquiry_email.map((email, index) => {
                return <React.Fragment key={index}>{email}</React.Fragment>;
              })}
          </div>
        </Col>
        <Col md={6} lg={4} xl={3} xs={4} className="pb-4" style={{borderRight: "1px solid #E0E0E0"}}>
          <div className="f14-700 pb-2">Pin/Zip code</div>
          <div className="f12-400">{props.vendor.pinCode}</div>
        </Col>
        <Col md={6} lg={4} xl={3} xs={4} className="pb-4" style={{borderRight: "1px solid #E0E0E0"}}>
          <div className="f14-700 pb-2">Country</div>
          <div className="f12-400">{props.vendor.country}</div>
        </Col>
        <Col md={6} lg={4} xl={3} xs={4} className="pb-4" style={{borderRight: "1px solid #E0E0E0"}}>
          <div className="f14-700 pb-2">Currency</div>
          <div className="f12-400">{props.vendor.currency}</div>
        </Col>
        <Col md={6} lg={4} xl={3} xs={4} className="pb-4" style={{borderRight: "1px solid #E0E0E0"}}>
          <div className="f14-700 pb-2">Time zone</div>
          <div className="f12-400">{props.vendor.timezone}</div>
        </Col>
      </Row>
      <hr />
      <div className="d-flex align-items-center pb-4">
        <div className="text-red f16-700 mr-1">Point of contact</div>
        <NavLink to="/editpointofcontacts" className="enIconBtnGraySmall">
          <Image
            src={require("../../../../assets/images/UserManagement/pencil.svg")}
            alt="Edit"
            title="Edit"
            fluid
          />
        </NavLink>
      </div>
      <Row>
        <Col md={6} lg={4} xl={3} xs={4} className="pb-4" style={{borderRight: "1px solid #E0E0E0"}}>
          <div className="f14-700 pb-2">Name</div>
          {!isEmpty(props.vendor.point_of_contact) &&
            props.vendor.point_of_contact.map((contact, index) => {
              return (
                <React.Fragment key={index}>
                  <div className="f12-400 d-flex mb-2">
                    {contact.firstName + " " + contact.lastName}
                    <div className="f12-400 ml-2">
                      ({contact.selected_position})
                    </div>
                  </div>
                </React.Fragment>
              );
            })}
        </Col>
        <Col md={6} lg={4} xl={3} xs={4} className="pb-4" style={{borderRight: "1px solid #E0E0E0"}}>
          <div className="f14-700 pb-2">Enquiry Email</div>
          {!isEmpty(props.vendor.point_of_contact) &&
            props.vendor.point_of_contact.map((contact, index) => {
              return (
                <React.Fragment key={index}>
                  <div className="f12-400 text-break mb-2">
                    {contact.enquiry_emails}
                  </div>
                </React.Fragment>
              );
            })}
        </Col>
        <Col md={6} lg={4} xl={3} xs={4} className="pb-4" style={{borderRight: "1px solid #E0E0E0"}}>
          <div className="f14-700 pb-2">Phone No.</div>
          {!isEmpty(props.vendor.point_of_contact) &&
            props.vendor.point_of_contact.map((contact, index) => {
              return (
                !isEmpty(contact.phone_numbers) &&
                contact.phone_numbers.map((phone, index) => {
                  return (
                    <React.Fragment key={index}>
                      <div className="f12-400 mb-2">
                        {phone.country_code + " " + phone.mobile_no}
                      </div>
                    </React.Fragment>
                  );
                })
              );
            })}
        </Col>
      </Row>
      <hr />
      <div className="d-flex align-items-center pb-4">
        <div className="text-red f16-700 mr-1">Business Settings</div>
        <NavLink to="/editrestaurantimage" className="enIconBtnGraySmall">
          <Image
            src={require("../../../../assets/images/UserManagement/pencil.svg")}
            alt="Edit"
            title="Edit"
            fluid
          />
        </NavLink>
      </div>
      <Row>
        {console.log(props.vendor)}
        <Col md={6} lg={4} xl={3} xs={6} className="pb-4" style={{borderRight: "1px solid #E0E0E0"}}>
          <div className="f14-700 pb-2">Business Description</div>
          <div className="f12-400">{props.vendor.restaurant_description}</div>
        </Col>
        <Col md={6} lg={4} xl={3} xs={6} className="pb-4" style={{borderRight: "1px solid #E0E0E0"}}>
          <div className="f14-700 pb-2">Logo</div>
          <div className="enIMG62">
            <Image
              fluid
              src={props.vendor && props.vendor.logo_url}
              alt="Business logo"
              title="Business logo"
              className="w-100 h-100"
            />
          </div>
        </Col>
        <Col md={6} lg={4} xl={3} xs={6} className="pb-4" style={{borderRight: "1px solid #E0E0E0"}}>
          <div className="f14-700 pb-2">Photos</div>
          <div className="d-flex flex-wrap">
            {!isEmpty(props.vendor) &&
              props.vendor.restaurant_pictures.map((data, index) => {
                return (
                  <React.Fragment key={index}>
                    <div className="enIMG97 mr-2 mb-2">
                      <Image
                        fluid
                        src={data}
                        alt="Business Pic"
                        title="Business Pic"
                        className="w-100 h-100"
                      />
                    </div>
                  </React.Fragment>
                );
              })}
          </div>
        </Col>
        <Col md={6} lg={4} xl={3} xs={6} className="pb-4" style={{borderRight: "1px solid #E0E0E0"}}>
          <div className="f14-700 pb-2">Video</div>
          {props.vendor.restaurant_video === "" ? (
            <p className="text-red f14-500">Video Not Available</p>
          ) : props.vendor.restaurant_video !== undefined &&
            props.vendor.restaurant_video !== null ? (
            <div className="">
              <video
                width="100%"
                height="100%"
                controls
                src={props.vendor.restaurant_video}
                type="video/mp4"
              />
            </div>
          ) : null}
        </Col>
        <Col md={6} lg={4} xl={3} xs={6} className="pb-4" style={{borderRight: "1px solid #E0E0E0"}}>
          <div className="f14-700 pb-2">Things To Do Nearby</div>
          <div className="f12-400">{props.vendor.things_nearby}</div>
        </Col>
        <Col md={6} lg={4} xl={3} xs={6} className="pb-4">
          <div className="f14-700 pb-2">Chain Details</div>
          <div className="d-flex align-items-center">
            <div className="enIMG62 mr-2">
              <Image
                fluid
                src={
                  props.vendor &&
                  props.vendor.restaurant_chain_id &&
                  props.vendor.restaurant_chain_id.icon
                }
                alt="Business logo"
                title="Business logo"
                className="w-100 h-100"
              />
            </div>
            <p className="f14-500">
              {props.vendor &&
                props.vendor.restaurant_chain_id &&
                props.vendor.restaurant_chain_id.title}
            </p>
          </div>
        </Col>
      </Row>
      <hr />
      <Row>
        <Col md={6} lg={4} xl={3} xs={4} className="pb-4" style={{borderRight: "1px solid #E0E0E0"}}>
          <div className="d-flex align-items-center pb-2">
            <div className="f16-700 mr-1">Business Type</div>
            <NavLink to="/editrestauranttype" className="enIconBtnGraySmall">
              <Image
                src={require("../../../../assets/images/UserManagement/pencil.svg")}
                alt="Edit"
                title="Edit"
                fluid
              />
            </NavLink>
          </div>
          <div className="f12-400">
            {!isEmpty(props.vendor) &&
              props.vendor.selected_restaurant_type.map((data, index) => {
                return (
                  <React.Fragment key={index}>{data.title}, </React.Fragment>
                );
              })}
          </div>
        </Col>
        <Col md={6} lg={4} xl={3} xs={4} className="pb-4" style={{borderRight: "1px solid #E0E0E0"}}>
          <div className="d-flex align-items-center pb-2">
            <div className="f16-700 mr-1">Payment Methods</div>
            <NavLink to="/editpaymentmethod" className="enIconBtnGraySmall">
              <Image
                src={require("../../../../assets/images/UserManagement/pencil.svg")}
                alt="Edit"
                title="Edit"
                fluid
              />
            </NavLink>
          </div>
          <div className="f12-400">
            {!isEmpty(props.vendor) &&
              props.vendor.selected_payment_methods.map((data, index) => {
                return (
                  <React.Fragment key={index}>{data.title}, </React.Fragment>
                );
              })}
          </div>
        </Col>
        <Col md={6} lg={4} xl={3} xs={4} className="pb-4" style={{borderRight: "1px solid #E0E0E0"}}>
          <div className="d-flex align-items-center pb-2">
            <div className="f16-700 mr-1">Parking</div>
            <NavLink to="/editparking" className="enIconBtnGraySmall">
              <Image
                src={require("../../../../assets/images/UserManagement/pencil.svg")}
                alt="Edit"
                title="Edit"
                fluid
              />
            </NavLink>
          </div>
          <div className="f12-400">
            {!isEmpty(props.vendor) &&
              props.vendor.selected_parking_type.map((data, index) => {
                return (
                  <React.Fragment key={index}>{data.title}, </React.Fragment>
                );
              })}
          </div>
        </Col>
        <Col md={6} lg={4} xl={3} xs={4} className="pb-4" style={{borderRight: "1px solid #E0E0E0"}}>
          <div className="d-flex align-items-center pb-2">
            <div className="f16-700 mr-1">Pets Allowed</div>
            <NavLink to="/editpetsallowed" className="enIconBtnGraySmall">
              <Image
                src={require("../../../../assets/images/UserManagement/pencil.svg")}
                alt="Edit"
                title="Edit"
                fluid
              />
            </NavLink>
          </div>
          <div className="f12-400">
            {!isEmpty(props.vendor) &&
              props.vendor.selected_pet_allowance.map((data, index) => {
                return (
                  <React.Fragment key={index}>{data.title}, </React.Fragment>
                );
              })}
          </div>
        </Col>
        <Col md={6} lg={4} xl={3} xs={4} className="pb-4" style={{borderRight: "1px solid #E0E0E0"}}>
          <div className="d-flex align-items-center pb-2">
            <div className="f16-700 mr-1">Dress Code</div>
            <NavLink to="/editdresscode" className="enIconBtnGraySmall">
              <Image
                src={require("../../../../assets/images/UserManagement/pencil.svg")}
                alt="Edit"
                title="Edit"
                fluid
              />
            </NavLink>
          </div>
          <div className="f12-400">
            {!isEmpty(props.vendor) &&
              props.vendor.selected_dress_code.map((data, index) => {
                return (
                  <React.Fragment key={index}>{data.title}, </React.Fragment>
                );
              })}
          </div>
        </Col>
        <Col md={6} lg={4} xl={3} xs={4} className="pb-4" style={{borderRight: "1px solid #E0E0E0"}}>
          <div className="d-flex align-items-center pb-2">
            <div className="f16-700 mr-1">Accessibility</div>
            <NavLink to="/editaccessibility" className="enIconBtnGraySmall">
              <Image
                src={require("../../../../assets/images/UserManagement/pencil.svg")}
                alt="Edit"
                title="Edit"
                fluid
              />
            </NavLink>
          </div>
          <div className="f12-400">
            {!isEmpty(props.vendor) &&
              props.vendor.selected_accessibilty.map((data, index) => {
                return (
                  <React.Fragment key={index}>{data.title}, </React.Fragment>
                );
              })}
          </div>
        </Col>
        <Col md={6} lg={4} xl={3} xs={4} className="pb-4" style={{borderRight: "1px solid #E0E0E0"}}>
          <div className="d-flex align-items-center pb-2">
            <div className="f16-700 mr-1">Other Features</div>
            <NavLink to="/editotherfeatures" className="enIconBtnGraySmall">
              <Image
                src={require("../../../../assets/images/UserManagement/pencil.svg")}
                alt="Edit"
                title="Edit"
                fluid
              />
            </NavLink>
          </div>
          <div className="f12-400">
            {!isEmpty(props.vendor) &&
              props.vendor.selected_other_features.map((data, index) => {
                return (
                  <React.Fragment key={index}>{data.title}, </React.Fragment>
                );
              })}
          </div>
        </Col>
        <Col md={6} lg={4} xl={3} xs={4} className="pb-4" style={{borderRight: "1px solid #E0E0E0"}}>
          <div className="d-flex align-items-center pb-2">
            <div className="f16-700 mr-1">Services Offered</div>
            <NavLink to="/editserviceoffered" className="enIconBtnGraySmall">
              <Image
                src={require("../../../../assets/images/UserManagement/pencil.svg")}
                alt="Edit"
                title="Edit"
                fluid
              />
            </NavLink>
          </div>
          <div className="f12-400">
            {!isEmpty(props.vendor) &&
              props.vendor.selected_services_offered.map((data, index) => {
                return (
                  <React.Fragment key={index}>{data.title}, </React.Fragment>
                );
              })}
          </div>
        </Col>
        <Col md={6} lg={4} xl={3} xs={4} className="pb-4" style={{borderRight: "1px solid #E0E0E0"}}>
          <div className="d-flex align-items-center pb-2">
            <div className="f16-700 mr-1">Located Inside</div>
            <NavLink to="/editlocatedinside" className="enIconBtnGraySmall">
              <Image
                src={require("../../../../assets/images/UserManagement/pencil.svg")}
                alt="Edit"
                title="Edit"
                fluid
              />
            </NavLink>
          </div>
          <div className="f12-400">
            {!isEmpty(props.vendor) &&
              props.vendor.selected_located_inside.map((data, index) => {
                return (
                  <React.Fragment key={index}>{data.title}, </React.Fragment>
                );
              })}
          </div>
        </Col>
        <Col md={6} lg={4} xl={3} xs={4} className="pb-4" style={{borderRight: "1px solid #E0E0E0"}}>
          <div className="d-flex align-items-center pb-2">
            <div className="f16-700 mr-1">Point of Sale System</div>
            <NavLink to="/editpointofsale" className="enIconBtnGraySmall">
              <Image
                src={require("../../../../assets/images/UserManagement/pencil.svg")}
                alt="Edit"
                title="Edit"
                fluid
              />
            </NavLink>
          </div>
          <div className="f12-400">
            {!isEmpty(props.vendor) &&
              props.vendor.selectedPointOfSale.map((data, index) => {
                return (
                  <React.Fragment key={index}>{data.title}, </React.Fragment>
                );
              })}
          </div>
        </Col>
      </Row>
      <hr />
      <Row className="pb-5">
        <Col md={6} lg={4} xl={3} xs={4} className="pb-4" style={{borderRight: "1px solid #E0E0E0"}}>
          <div className="d-flex align-items-center pb-2">
            <div className="f16-700 mr-1">Business Hours of Operations</div>
            <NavLink to="/editbusinesshours" className="enIconBtnGraySmall">
              <Image
                src={require("../../../../assets/images/UserManagement/pencil.svg")}
                alt="Edit"
                title="Edit"
                fluid
              />
            </NavLink>
          </div>
          <div className="f12-400">View Timings</div>
        </Col>
      </Row>
    </React.Fragment>
  );
};
export default AboutSection;
